import React from 'react';
import { css } from '@emotion/react';
import NvIcon from 'shared/components/nv-icon';
import { danger, hexToRgbaString } from 'styles/global_defaults/colors';

export type NotAvailableContainerProps = {
  icon: string
  text: string
};

export const NotAvailableGreyContainer = ({ icon, text }: NotAvailableContainerProps) => (
  <div className='not-available-grey-container bg-gray-6 d-flex flex-column justify-content-between align-items-center p-4 text-gray-3 w-100 my-5'>
    <NvIcon icon={icon} size='medium-large' />
    <div className='mt-2'>{text}</div>
  </div>
);

const redContainerStyles = css`
  background-color: ${hexToRgbaString(danger, 0.05)};
  border: 1px dashed ${danger};
`;

export type NotAvailableRedContainerProps = {
  children: React.ReactNode
  className?: string
};

export const NotAvailableRedContainer = ({ children, className }: NotAvailableRedContainerProps) => (
  <div
    css={redContainerStyles}
    className={`d-flex align-items-center justify-content-center text-center px-5 py-4 mt-4 w-100${className ? ` ${className}` : ''}`}
  >
    {children}
  </div>
);
